import request from '@/utils/httpClient'

// 获取tree
export function getTree(url: string, params?: object) {
  return request({
    url,
    method: 'get',
    params
  })
}

// 获取列表
export function getPageList(url: string, params?: object) {
  return request({
    url,
    method: 'get',
    params
  })
}

// 根据id获取业务列表
export function getBusinessInfo(apiPath: string, id: number) {
  return request({
    url: `${apiPath}/${id}/actions/businesses`,
    method: 'get'
  })
}

// 动态表单新建
export function createFormData(api: string, data?: object, method?: string) {
  const _method = method ? 'PUT' : 'POST'
  return request({
    url: api,
    method: _method,
    data
  })
}

// 动态表单更新
export function updateFormData(api: string, id: number, data?: object) {
  return request({
    url: `${api}/${id}`,
    method: 'put',
    data
  })
}
